interface spinnerPropsInterface {
    spinnerContainerClassName?: string
    hidden?: boolean | undefined
    spinnerClassName?: string
    spinnerSpanClassName?: string
}

export default function Spinner(props: spinnerPropsInterface) {
    return (
        <div className={ props.spinnerContainerClassName } hidden={ props.hidden }>
            <div className={ props.spinnerClassName + " spinner-border m-0 p-0" } role="status">
                <span className={ props.spinnerSpanClassName + " sr-only" }></span>
            </div>
        </div>
    )
}